import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
const Topper = () => {
    var settings = {
        loop: true,
        margin: 10,
        responsiveClass: true,
        autoplay: true,
        dots: true,
        items: 4,
        responsive: {
            0: {
                items: 1,
            },
            567: {
                items: 2,
            },
            768: {
                items: 4,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 4,
            },
            1600: {
                items: 4,
            }
        }
    };

    return (
        <>
        <div className="tpr-block">
            <div className='tpr-class-img'>
                <img src="/Images/12.png" />
            </div>
        <OwlCarousel className='owl-theme topper-theme' loop margin={10} {...settings}>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper1.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>Maths</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper2.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>Maths</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper1.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>Maths</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper2.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>Maths</p>
                </div>
            </div>
        </OwlCarousel>
        </div>
        <div className="tpr-block">
            <div className='tpr-class-img'>
                <img src="/Images/10.png" />
            </div>
        <OwlCarousel className='owl-theme topper-theme' loop margin={10} {...settings}>
            
            <div className="item">
                <div className='topper-img'>
                    <img src="/Images/topper1.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>X-B</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper2.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>X-A</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper1.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>X-A</p>
                </div>
            </div>
            <div className="item">
                <div className='topper-img'>
                <img src="/Images/topper2.png"></img>
                </div>
                <div className='topper-cont'>
                    <p className='percent'>98.2%</p>
                    <p>Manisha Kataria</p>
                    <p>X-B</p>
                </div>
            </div>

        </OwlCarousel>
        </div>
        </>
    );
};

export default Topper;
